import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AccountStorageResetService } from '../services/account-storage-reset.service';

@Injectable({ providedIn: 'root' })
export class AccountLogoutGuard implements CanActivate {
  constructor(
    private readonly accountStorageReset: AccountStorageResetService,
    private readonly router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this.accountStorageReset.resetAccountData();
    return this.router.parseUrl('/login');
  }
}
